import axios from "@/plugins/axios";
import utils from "@/stores/utils";
import { migrateCatalogEntryFormatFilter } from "@/utils/apiFilterParams";

const state = {
    search: null,
    recurring: false,
    catalog: null,
    catalogentry: null,
    customer_id: null,
    entry_type: null,

    catalogentries: null,
    catalogentries_count: 0,
    catalogentries_filters: { limit: 1000, trigger: "manual" },
    catalogentries_loading: false,
    catalogentries_loading_errors: null,
    catalogentries_cancel_source: null,
    customer_catalog_cancel_source: null,
};

const mutations = {
    updateCatalog(state, catalog) {
        state.catalog = catalog;
    },
    updateRecurring(state, recurring) {
        state.recurring = recurring;
        state.catalogentries_filters.recurring = recurring;
        state.entry_type = "service";
    },
    updateCustomerId(state, customer_id) {
        state.customer_id = customer_id;
        state.catalogentries_filters.for_customer = customer_id;
    },

    updateSearch(state, search) {
        state.catalogentries_filters.search = search;
    },
    updateCatalogEntry(state, catalogentry) {
        state.catalogentry = catalogentry;
    },

    updateCatalogEntries(state, catalogentries) {
        state.catalogentries = catalogentries;
    },
    updateCatalogEntriesCount(state, count) {
        state.catalogentries_count = count;
    },
    updateCatalogEntriesLoading(state, loading) {
        state.catalogentries_loading = loading;
    },
    updateCatalogEntriesLoadingErrors(state, errors) {
        state.catalogentries_loading_errors = errors;
    },
    updateEntryType(state, entry_type) {
        state.entry_type = entry_type;
        state.catalogentries_filters.type = entry_type;
    },
    updateCatalogEntriesCancelSource(state, cancel_source) {
        state.catalogentries_cancel_source = cancel_source;
    },
    updateCustomerCatalogCancelSource(state, cancel_source) {
        state.customer_catalog_cancel_source = cancel_source;
    },
};

const actions = {
    async fetchCatalogEntries({ commit, dispatch, state }, params) {
        commit("updateCatalogEntriesLoading", true);
        commit("updateCatalogEntriesLoadingErrors", null);

        if (state.catalogentries_cancel_source) {
            state.catalogentries_cancel_source.cancel("canceled");
        }

        const cancelSource = axios.CancelToken.source();
        commit("updateCatalogEntriesCancelSource", cancelSource);

        try {
            const response = await axios.get("/api/catalogentries/", {
                params: migrateCatalogEntryFormatFilter(state.catalogentries_filters),
                cancelToken: state.catalogentries_cancel_source?.token
            });
            commit("updateCatalogEntries", response.data.results);
            commit("updateCatalogEntriesCount", response.data.count);
            commit("updateCatalogEntriesCancelSource", null);
            return response;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            const error = utils.handleError(xhr_error);
            commit("updateCatalogEntriesLoadingErrors", error.details);
            throw error;
        } finally {
            commit("updateCatalogEntriesLoading", false);
        }
    },

    async fetchCustomerCatalog({ commit, dispatch, state }, params) {
        if (state.customer_catalog_cancel_source) {
            state.customer_catalog_cancel_source.cancel("canceled");
        }

        const cancelSource = axios.CancelToken.source();
        commit("updateCustomerCatalogCancelSource", cancelSource);

        try {
            const response = await axios.get("/api/catalogassignments/", {
                params: { customer: state.customer_id },
                cancelToken: state.customer_catalog_cancel_source?.token
            });
            if (response.data.count) {
                commit("updateCatalog", response.data.results[0].catalog_data);
            } else {
                commit("updateCatalog", null);
            }
            commit("updateCustomerCatalogCancelSource", null);
            return response;
        } catch (xhr_error) {
            if (axios.isCancel(xhr_error)) {
                return;
            }
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

    setCustomerId({ commit, dispatch, state }, customer_id) {

        commit("updateCustomerId", customer_id);
        dispatch("fetchCustomerCatalog");
    },

    setSearch({ commit, dispatch, state }, search) {

        commit("updateSearch", search);
        dispatch("fetchCatalogEntries");
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
